import { styled, PopoverProps, Popover } from '@mui/material';
import HoverPopover from 'material-ui-popup-state/HoverPopover';

import { Card, DsShadow } from '@cast/design-system';
import { useIsTouchDevice } from '@cast/utils';

const SidebarPopperCard = styled(Card, {
  name: 'DsCard',
  slot: 'Root',
  overridesResolver: (_, styles) => {
    return [styles.popper];
  },
})(({ theme }) => ({
  borderRadius: '4px',
  boxShadow: theme.shadows[DsShadow.DROPDOWN],
  padding: 0,
}));

SidebarPopperCard.displayName = 'SidebarPopperCard';

export const SidebarPopover = ({
  children,
  testId,
  ...props
}: PopoverProps & { testId?: string }) => {
  const isTouch = useIsTouchDevice();

  const PopoverComponent = isTouch ? Popover : HoverPopover;

  return (
    <PopoverComponent
      {...props}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: -8, horizontal: 'left' }}
      disableScrollLock
      sx={{
        '& .MuiPaper-root': {
          boxShadow: 'none',
          backgroundColor: 'transparent',
          padding: '8px',
        },
      }}
    >
      <SidebarPopperCard testId={testId}>{children}</SidebarPopperCard>
    </PopoverComponent>
  );
};
